/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CouponDto } from '../../models/coupon-dto';

export interface ParentCouponControllerFindById$Params {
  id: string;
}

export function parentCouponControllerFindById(http: HttpClient, rootUrl: string, params: ParentCouponControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponDto>> {
  const rb = new RequestBuilder(rootUrl, parentCouponControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CouponDto>;
    })
  );
}

parentCouponControllerFindById.PATH = '/api/parent-coupon/{id}';
